import { Modal, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import { useForm } from "react-hook-form";
import { translate } from "ui/i18n";
import { CloseButton } from "ui/pages/app/components/buttons/CloseButton";
import { INTextarea } from "ui/pages/app/components/inputs/INTextarea";
import { Inputs } from "ui/pages/inputsType";
import { PrimaryButton } from "ui/pages/app/components/buttons/PrimaryButton";
import { useWindowWidth } from "ui/utils/hooks";
import { useAppSelector } from "ui/hook/store";
import { selectIsAIFeedbackLoading } from "domain/ai-search/ai-search.selectors";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (feedback: string) => void;
}

export function ModalAIFeedback({ isOpen, onClose, onSubmit }: IProps) {
  const isDesktop = useWindowWidth();
  const isLoading = useAppSelector(selectIsAIFeedbackLoading);
  const formManager = useForm<Inputs>({
    mode: "onSubmit",
    defaultValues: {
      feedback: "",
    },
  });
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = formManager;

  const handleFormSubmit = (data: Inputs) => {
    onSubmit(data.feedback);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        maxW="750px"
        margin="20px"
        className="!rounded-[30px] p-6 md:p-8"
      >
        <CloseButton onClick={onClose} className="mb-6 w-fit" />

        <div className="flex flex-col items-center space-y-12 px-10">
          <h4 className="font-bold text-secondaryGrey-900">
            {translate("ns1:AI.Modal.TellUsMore")}
          </h4>

          <INTextarea
            error={errors.feedback}
            className="w-full"
            placeholder={translate("ns1:Input.Placeholders.WriteHere")}
            register={{
              ...register("feedback", {
                required: translate("ns1:Input.Errors.Required"),
              }),
            }}
          />

          <PrimaryButton
            disabled={!isValid || isLoading}
            height={isDesktop ? "56px" : "46px"}
            width="100%"
            className="w-full"
            onClick={handleSubmit(handleFormSubmit)}
          >
            {translate("ns1:Button.Validate")}
          </PrimaryButton>
        </div>
      </ModalContent>
    </Modal>
  );
}
